import { Data, DataObject } from '@shared/models/data-object.model';

/**
 * Returns a function receiving data and returning given attribute of given data
 * @example
 * // given
 * const data = [{foo:'bar', baz:1 }, {foo:'bazbaz', baz:5 }]
 * // when
 * const bazValues = data.map(pick('baz'))
 * const fooValues = data.map(pick('foo'))
 * // then
 * bazValues // [1,5]
 * fooValues // ['bar','bazbaz']
 * @param attr
 * @returns
 */
export const pick = (attr: string) => (data: DataObject) => data[attr];

/**
 * Returns a function that reads specified values from data given to it
 *
 * @example
 * // given
 * x = {foo:'bar', baz:'bazbaz', holo:1}
 * toFooAndHolo = pickMany('foo','holo')
 * // when
 * toFooAndHolo(x)
 * // then
 * {foo: 'bar', holo: 1}
 */
export const pickMany =
  (...attrs: string[]) =>
  (data: Data): Data =>
    Object.assign({}, ...attrs.map(attr => ({ [attr]: data[attr] })));
